import Sheet from '@/components/ui/Sheet';
import EstadoVazio from '@/components/ui/EstadoVazio';
import { formatarDataMinuto } from '@/pages/gerenciar/utils';
import type { MemoriaItem } from '../types';

interface Props {
  aberto: boolean;
  aoFechar: () => void;
  memoria: MemoriaItem[];
}

export default function FolhaMemoria({ aberto, aoFechar, memoria }: Props) {
  const ordenada = [...memoria].sort(
    (a, b) => new Date(b.criado_em).getTime() - new Date(a.criado_em).getTime(),
  );

  return (
    <Sheet aberto={aberto} titulo="O que ele lembra" aoFechar={aoFechar}>
      {ordenada.length === 0 ? (
        <EstadoVazio
          icone="ri-brain-line"
          titulo="Ainda não guardei nada."
          descricao="Quando você disser um combinado, eu guardo aqui."
        />
      ) : (
        <div className="space-y-2">
          {ordenada.map((m) => (
            <div key={m.id} className="rounded-[14px] bg-background-100 px-4 py-3">
              <p className="text-[14px] leading-relaxed text-foreground-900">{m.texto}</p>
              <p className="mt-1 text-[12px] text-foreground-500">{formatarDataMinuto(m.criado_em)}</p>
            </div>
          ))}
          <p className="px-1 pt-1 text-[12px] text-foreground-500">
            Para apagar ou corrigir, peça no chat: &quot;esqueça isso&quot;.
          </p>
        </div>
      )}
    </Sheet>
  );
}